(function ($) {

	function propertiesSlider() {
		$(".product-property-slider").each(function () {
			var $this = $(this);
			var infoSlider = new Swiper($this.find('.swiper-container').get(0), {
				slidesPerView: 'auto',
				freeMode: true,
				observer: true,
				watchOverflow: true,
				watchSlidesVisibility: true,
				mousewheel: {
					forceToAxis: true,
				},
			});
			window.onresize = function () {
				infoSlider.update();
			}
			if ($this.find(".swiper-slide").length === 1) {
				infoSlider.destroy();
			}
		});
	}


	$(document).gp_ready(function () {
		propertiesSlider();
	})

	var w = $(window).width();
	window.addEventListener('resize', () => {
		clearTimeout(window.resizedFinished);
		if ($(window).width() === w) return;
		w = $(window).width();
		window.resizedFinished = setTimeout(function () {
			propertiesSlider();
		}, 250);
	});

})(jQuery);
